module.exports = __webpack_public_path__ + "img/zoom-addin-01.d13e17f5.png";